.checkboxContainer {
    display: flex;
    align-items: center;
    margin-left: -10px;
}